import { ProcessInfo } from './process-info';
import { ProcessResult } from './process-result';

/**
 * Result class for vector-based processes (DLA, Nastran, ThicknessUpdate)
 * Inherits from ProcessResult and adds interpolation information
 */
export class VectorResult extends ProcessResult {
  IsInterpolated: boolean;
  ProcessInfos: ProcessInfo[];

  constructor(data: any) {
    super(data);
    this.IsInterpolated = data.IsInterpolated;
    this.ProcessInfos = data.ProcessInfos || [];
  }
}
